import equals from '../Utilities/equals';
import getHash from '../Utilities/getHash';
import DefaultStringComparer from './DefaultStringComparer';
/**
 * Default implementation
 */
export default class DefaultObjectComparer {
    compare(x, y) {
        var _a, _b;
        const toStringMethodName = 'toString';
        const x_toString = (_a = x[toStringMethodName]) === null || _a === void 0 ? void 0 : _a.call(x);
        const y_toString = (_b = y[toStringMethodName]) === null || _b === void 0 ? void 0 : _b.call(y);
        if (x_toString !== undefined // if there is no toString(), lets serialize it with a hash
            && x_toString !== {}.toString() // if it is an object type, lets serialize it with a hash
            && y_toString !== undefined // if there is no toString(), lets serialize it with a hash
            && y_toString !== {}.toString()) // if it is an object type, lets serialize it with a hash
         {
            return new DefaultStringComparer().compare(x_toString, y_toString);
        }
        else {
            return new DefaultStringComparer().compare(getHash(x), getHash(y));
        }
    }
    equals(x, y) {
        return equals(x, y, true);
    }
    greaterThan(x, y) {
        return this.compare(x, y) > 0;
    }
    greaterThanOrEqual(x, y) {
        return this.compare(x, y) >= 0;
    }
    lessThan(x, y) {
        return this.compare(x, y) < 0;
    }
    lessThanOrEqual(x, y) {
        return this.compare(x, y) <= 0;
    }
}
